<template>
	<el-container>
		<!-- <el-header class="greenmenu">
			<span @click="$router.back(-1)" class="backstr">
				<返回</span> <span class="header_h2">预约分院
			</span>
		</el-header> -->
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="toback()"
				:src='"/img/webimg/back.png"' alt=""> -->
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="toback()" icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">预约分院 </span>
		</el-header>
		<el-row type="flex" justify="center">
			<el-col :span="24">
				<div style=" width: 300px;margin-top: 20px;" v-for="(item,$index) in BranchList">
					<el-row>
						<el-col :span="6">
							<div>
								<img v-if="item.branch_img!=''" style="max-width: 50px;" :src='"/img"+ item.branch_img'
									alt="">
								<img v-if="item.branch_img==''" style="max-width: 50px;"
									:src='"/img/webimg/branchdefault.png"' alt="">
							</div>
						</el-col>
						<el-col :span="18">
							<div style="font-size: small;text-align: left;">
								<li><b>分院名称：</b>{{item.branch_name}}</li>
								<li><b>分院地址：</b>{{item.branch_address}}</li>
								<li><b>联系电话：</b>{{item.branch_tel}}</li>
								<!-- <button class="bluebuttonsmall" style="float: right;"  @click="toSelBookdate(item)">确认选择</button> -->
								<el-button size="mini" type="primary" style="float: right;"
									@click="toSelBookdate(item)">确认选择</el-button>

							</div>

						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<!-- <div class="branch">
			<div v-for="(item,$index) in BranchList">
				<ul style="float: left;border: #0069D9; height: 100px;margin: auto;">
					<li style="width: 100px;height: 100px;">

						<img v-if="item.branch_img!=''" class="imgsize" :src='"/img"+ item.branch_img' alt="">
<img v-if="item.branch_img==''" class="imgsize" :src='"/img/webimg/branchdefault.png"' alt="">
					</li>
				</ul>
				

			</div>
		</div> -->
		<el-container>
			<RouterView></RouterView>
		</el-container>



	</el-container>
</template>

<script>
	import branch from '../../apifunction/Branch.js'
	export default {
		created() {
			this.initData();
		},
		data() {
			return {
				curcorpid: '',
				BranchList: [],
				curcus: null
			};
		},
		watch: {
			// 如果路由发生变化，再次执行该方法
			"$route": "initData"
		},
		methods: {
			initData() {
				this.curcus = JSON.parse(this.$route.query.ent)
				this.curcorpid = this.curcus.corpid;
				if (this.curcus.orderid != '') {
					branch.GetBranchByOrderID(this.curcus.orderid)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								if (ent.Data != 'null')
									this.BranchList = JSON.parse(ent.Data);
								else
									this.BranchList = []
							} else
								this.$message.info(ent.Msg);
						})
				} else {
					branch.GetBranchByCorpID(this.curcorpid)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								if (ent.Data != 'null')
									this.BranchList = JSON.parse(ent.Data);
								else
									this.BranchList = []
							} else
								this.$message.info(ent.Msg);
						})
				}

			},
			toSelBookdate: function(ent) {
				var data = {
					path: '/selbookdate',
					query: {
						ent: JSON.stringify(ent),
						entcus: JSON.stringify(this.curcus),
					}
				};

				this.$router.push(data)
			},
			toback: function() {

				if (this.curcus.orderid != '') {
					var data = {
						path: '/BookGroupSel',
						query: {
							ent: JSON.stringify(this.curcus)
						}
					};
					this.$router.push(data)
				} else {
					var data = {
						path: '/BookForSingle',
						query: {
							ent: JSON.stringify(this.curcus)
						}
					}
					this.$router.push(data)

				}
			}
		}
	}
</script>

<style>
</style>
